export const types = {
    OPEN: 'OPEN',
    INSDELROW: 'INSERT-DELETE-ROW',
    INSDELCOL: 'INSERT-DELETE-COLUMN',
    COPY: 'COPY',
    PASTE: 'PASTE',
    PIVOT: 'CREATE-PIVOT',
    EXPORTCSV: 'EXPORT-TO-CSV',
    WRITECELL: 'WRITE-CELL',
    VLOOKUP: 'VLOOKUP',
    READSHEET: 'READ-SHEET',
    SAVE: 'SAVE',
    SETCELLFORMULA: 'SET-CELL-FORMULA',
    RUNMACRO: 'RUN-MACRO',
    WRITERANGE: 'WRITE-RANGE'
};
